import { storageRunnit1 } from '@/firebase';

// Download URLs for feedback reports' private files in the runnit-1 bucket, asked for once per page
// load: the list's previews, the open report's screenshots and its bundle share them. A failed ask
// is forgotten, so the next one tries again.
const urls: Map<string, Promise<string>> = new Map();

export const feedbackFileUrl = (path: string): Promise<string> => {
	let url: Promise<string> | undefined = urls.get(path);
	if (!url) {
		url = storageRunnit1.ref(path).getDownloadURL() as Promise<string>;
		url.catch(() => urls.delete(path));
		urls.set(path, url);
	}
	return url;
};
